let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dJC82")).then(() => parcelRequire('kM0Bh'));